// extracted by mini-css-extract-plugin
module.exports = {"icone":"ItemDados_icone__3le1B","iconeFA":"ItemDados_iconeFA__1q2Og","textarea":"ItemDados_textarea__1Io1e","descricaoItem":"ItemDados_descricaoItem__3vD5w"};